(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define("Generic", [
      'jquery',
      'main.js',
      'imagesloaded',
      'masonry',
      'tenementMap'
    ], factory);
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory(
      require('jquery'),
      require('main.js'),
      require('imagesloaded'),
      require('masonry-layout'),
      require("tenementMap")
    );
  } else {
    // Browser globals (root is window)
    root.returnExports = factory(root.main, root.imagesloaded, root.masonry, root.TenementMap);
  }
}(typeof self !== 'undefined' ? self : this, function ($, main, imagesLoaded, Masonry, TenementMap) {

  $(function () {
    /* about us layout ordering */
    function layoutOrderInit() {
      var msnry = new Masonry('.c-testimonials__inner', {
        itemSelector: '.c-testimonials__item',
        percentPosition: true,
        gutter: '.gutter-sizer',
        horizontalOrder: true
      });
    }

    if ($('.c-testimonials').length) {
      imagesLoaded('.c-testimonials', function () {
        // images have loaded
        layoutOrderInit();
      });
    }

    new TenementMap({
      tenementMapID: "tenementMap"
    });

    let isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

    $(window).on('resize', function () {
      if ($('.subPage').length && isIE11) {
        window.location.reload();
      }
    });

  });
}));



//////////////////
// WEBPACK FOOTER
// ./js/src/generic.js
// module id = 13
// module chunks = 1